module.exports = __webpack_public_path__ + "assets/img/ai-output.e1e41cc7.svg";